import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import '@/styles/FallBackPage.css';
import { Logo } from '@/components/Logo';
import Title from '@/components/Title';
import BackgroundFallBack from '@/components/BackgroundFallBack';
import FallBackForm from '@/components/FallBackForm';
/**
 * FallBackPage component.
 *
 * This component represents the fallback page of the application. It includes a background, logo, title, and a fallback form.
 *
 * @returns {JSX.Element} The FallBackPage component.
 */
const FallBackPage = () => {
    const [useImageBackground] = React.useState(true);
    return (_jsxs("div", Object.assign({ className: "login-container" }, { children: [_jsx(BackgroundFallBack, { useImageBackground: useImageBackground }), _jsx(Logo, {}), _jsx(Title, {}), _jsxs("div", Object.assign({ className: "login-form-container" }, { children: [_jsx(FallBackForm, {}), " "] }))] })));
};
export default FallBackPage;
